import { Injectable } from '@angular/core';
import { Practitioner, Facility, Location, Hours, PractitionerDetails, FacilityDetails, FacilityLocation } from '../interfaces/search-result-object.interface';
import { CareTypeTerms, FilterTerms } from '../models/FIlterTerms';
import { SearchObjectService } from './search-object.service';

@Injectable()
export class SearchResultObjectService {
    constructor(private searchObjectService: SearchObjectService) {
    }

    setResults(objArray: any[]): SearchResultObject[] {
        const results = [];

        for(const obj of objArray) {
            let resultObj;
            if(obj.subType === FilterTerms.Practitioner) {
                resultObj = this.setPractitionertoResult(obj);
            } else if(obj.subType === FilterTerms.Facility || obj.subType === CareTypeTerms.Pharmacy) {
                resultObj = this.setFacilityToResult(obj);
            }

            results.push(resultObj);
        }

        return results;
    }

    setPractitionertoResult(obj: any): SearchResultObject {
        const resultObj = new SearchResultObject();
        const practitioner: Practitioner = <Practitioner>obj;

        resultObj.type = FilterTerms.Practitioner;
        resultObj.id = practitioner.id;
        resultObj.acceptingNewPatients = practitioner.acceptingNewPatients;
        resultObj.fullName = practitioner.fullName;
        resultObj.providerNumber = practitioner.providerNumber;
        resultObj.specialty = practitioner.specialty;
        resultObj.specialties = practitioner.location ? practitioner.location.specialties : [];
        resultObj.restriction = practitioner.restriction ? practitioner.restriction : null;
        resultObj.isLGBTQIAPlusAffirmingProvider = practitioner.isLGBTQIAPlusAffirmingProvider ? practitioner.isLGBTQIAPlusAffirmingProvider : false;
        resultObj.locationCount = practitioner.locationCount;
        resultObj.locations = practitioner.location ? [practitioner.location] : [];
        resultObj.distance = practitioner.distance;
        resultObj.dataSource = practitioner.dataSource;
        if(this.searchObjectService.getNetworkID()) {
            resultObj.networkId = this.searchObjectService.getNetworkID();
        }

        if(this.searchObjectService.getAddress()) {
            resultObj.address = this.searchObjectService.getAddress();
        }

        if(this.searchObjectService.getSubProductKey()) {
            resultObj.subProductKey = this.searchObjectService.getSubProductKey();
        }

        if(this.searchObjectService.getLoginType()) {
            resultObj.loginType = this.searchObjectService.getLoginType();
        }

        return resultObj;
    }

    setFacilityToResult(obj: any): SearchResultObject {
        const resultObj = new SearchResultObject();
        const facility: Facility = <Facility>obj;

        resultObj.type = FilterTerms.Facility;
        resultObj.id = facility.id;
        resultObj.fullName = facility.fullName;
        resultObj.providerNumber = facility.providerNumber;
        resultObj.restriction = facility.restriction ? facility.restriction : null;
        resultObj.specialties = facility.location ? facility.location.specialties : [];
        resultObj.locationCount = 1;
        resultObj.locations = facility.location ? [facility.location] : [];
        if(resultObj.locations.length > 0) {
            this.check24HourLocation(resultObj.locations);
        }
        resultObj.dataSource = facility.dataSource;

        if(this.searchObjectService.getNetworkID()) {
            resultObj.networkId = this.searchObjectService.getNetworkID();
        }

        if(this.searchObjectService.getAddress()) {
            resultObj.address = this.searchObjectService.getAddress();
        }

        if(this.searchObjectService.getSubProductKey()) {
            resultObj.subProductKey = this.searchObjectService.getSubProductKey();
        }

        if(this.searchObjectService.getLoginType()) {
            resultObj.loginType = this.searchObjectService.getLoginType();
        }

        return resultObj;

    }

    check24HourLocation(locationsArr) {
        if(locationsArr.length > 0) {
            const str = '00:00 am - 12:00 pm';
            const str2 = '00:00 am - 12:00 am';

            for(const location of locationsArr) {
                if(location.hours.some(obj => obj.scheduledHoursText === str) || location.hours.some(obj => obj.scheduledHoursText === str2)) {
                    location.open247 = true;
                }
            }
        }
    }

    setPractitionerDetailtoResult(obj: any): PractitionerDetails {
        const practitionerDetails: PractitionerDetails = <PractitionerDetails>obj;
        practitionerDetails.restriction = practitionerDetails.restrictionDescription ? practitionerDetails.restrictionDescription : '';
        practitionerDetails.locations.forEach((o) => {
            o.isInView = false;
        });

        return practitionerDetails;
    }

    setFacilityDetailtoResult(obj: any): FacilityDetails {
        const facilityDetails: FacilityDetails = <FacilityDetails>obj;
        if(facilityDetails.locations.length > 0) {
            this.check24HourLocation(facilityDetails.locations);
        }

        return facilityDetails;
    }

    setLocationtoFacilityDetail(location: FacilityLocation): FacilityDetails {
        const facilityDetails: FacilityDetails = {} as any;

        facilityDetails.fullName = location.officeName;
        facilityDetails.isMedicaidProvider = false;
        facilityDetails.locations = [location];
        facilityDetails.locations.forEach((o) => {
            o.isInView = false;
        });
        if(facilityDetails.locations.length > 0) {
            this.check24HourLocation(facilityDetails.locations);
        }
        facilityDetails.providerKey = '';
        facilityDetails.providerNumber = '';
        facilityDetails.services = [];
        facilityDetails.subType = FilterTerms.Facility;

        return facilityDetails;
    }
}

export class SearchResultObject {
    type: string;
    id: string;
    networkId?: string;
    acceptingNewPatients: boolean;
    address?: string;
    subProductKey?: string;
    fullName: string;
    providerNumber: string;
    specialties: string[];
    specialty?: string;
    restriction?: string;
    locationCount: number;
    distance: string;
    locations: Location[];
    dataSource: {
      icon: string,
      name: string,
      message: string
    };
    hours?: Hours[];

    loginType?: string;
    position?: number;
    isLGBTQIAPlusAffirmingProvider?: boolean;
}
